// chakra
import { Box, Center, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
// helpers
import { cutAway } from "../../../Helpers/HelpfulFunctions";

//Type definitons
interface AnalyticsCardInterface {
  icon: any;
  title: string;
  subTitle: string;
}

const AnalyticsCard = ({ icon, title, subTitle }: AnalyticsCardInterface) => {
  return (
    <>
      <Center
        // mt={1}
        mb={2}
        fontSize="20px"
        textAlign="center"
        color="blue.500"
        // borderWidth="1px"
        // bg="blue.500"
        // color="white"
        // borderRadius="md" minW="40px" minH="35px"
      >
        {icon}
      </Center>

      {/* <Center
      fontSize="24px"
       mr={2}
       color="blue.500"
       borderRadius="md"
      // minW="40px" minH="35px"
      >
        {icon}
      </Center> */}

      {/* <TextIcon color="gray.500" mr={2} my="auto" fontSize="4xl">
        <use xlinkHref="../../../symbols.svg#quiz"></use>
      </TextIcon> */}

      <Tooltip label={subTitle} aria-label="analytics">
        <Box textAlign="center" w="100%" my="auto">
          <Text fontWeight={700}>{title}</Text>
          <Text isTruncated fontSize="sm" color="gray.500" fontWeight={700}>
            {cutAway(subTitle, 14)}
          </Text>
        </Box>
      </Tooltip>
    </>
  );
};

export default AnalyticsCard;
